import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import type {TaskStatusWSMessageType} from './types';

export interface SubscriptionsState {
  tasksStatus: {[taskId: string]: TaskStatusWSMessageType};
}

const initialState: SubscriptionsState = {
  tasksStatus: {},
};

const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    updateTaskStatus: (
      state,
      {payload}: PayloadAction<TaskStatusWSMessageType>
    ) => {
      state.tasksStatus[payload.task_key] = payload;
    },
  },
});

export const subscriptionsReducer = subscriptionsSlice.reducer;

export const {updateTaskStatus} = subscriptionsSlice.actions;
